'use strict';
const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'involuntary_cancellation',
    viewClass: require('./view'),
    modelClass: require('./model'),
    methods: {
        mmbOpen(pnr) {
            this.mmbOpen(pnr);
        },
        contactAirlineOpen(pnr) {
            this.openPNRInfoPopUp(pnr);
        },
        openRefundAlternatives(pnr) {
            this.openRefundAlternatives(pnr);
        },
    },
});
